module.exports = __webpack_public_path__ + "static/media/Cooked_fish.1bb24d7a.png";